// extracted by mini-css-extract-plugin
export var form = "_58-0";